<template>
  <div class="d-flex flex-column" style="gap: 16px">
    <!-- Lớp đang hoạt động -->
    <v-card class="d-flex flex-wrap overflow-hidden" style="border: 1px solid #dde3f0; border-radius: 16px; box-shadow: 0 2px 12px rgba(25, 50, 120, 0.08);" elevation="0">
      <div class="d-flex align-center justify-center pa-6 white--text flex-shrink-0" style="background: linear-gradient(to right, #0E66FF 0%, #0040B0 100%); border-radius: 16px; min-width: 260px;">
        <v-avatar color="white" size="84" class="mr-5">
          <v-icon color="#0040B0" size="48">mdi-google-classroom</v-icon>
        </v-avatar>
        <div>
          <div class="font-weight-bold" style="font-size: 48px; line-height: 1.1">{{ totalClasses }}</div>
          <div class="mt-1 text-no-wrap" style="font-size: 15px; opacity: 0.9;">Lớp đang hoạt động</div>
        </div>
      </div>

      <div class="d-flex align-center px-4 py-3 flex-grow-1" style="min-width: 0;">
        <div v-if="loadingGrades" class="py-2 text-center w-100">
          <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
        </div>
        <div v-else-if="!gradesData.length" class="py-2 text-body-2 grey--text w-100">
          Chưa có dữ liệu học sinh theo khối
        </div>
        <div v-else class="w-100" style="display: grid; grid-template-columns: repeat(2, max-content); gap: 12px 48px; justify-content: center; align-content: center; height: 100%;">
          <div v-for="item in gradesData" :key="item.grade" class="d-flex align-baseline" style="gap: 8px; padding: 4px 8px;">
            <span class="grey--text text--darken-1 text-no-wrap" style="font-size: 14px">• Khối {{ item.grade }}:</span>
            <span class="font-weight-bold" style="font-size: 16px; color: #202A63">{{ item.count | formatNumber }}</span>
            <span class="grey--text text--lighten-1" style="font-size: 13px">hs</span>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Học sinh + Giáo viên -->
    <div class="d-flex flex-column flex-sm-row" style="gap: 16px">
      <!-- Học sinh -->
      <stat-card
        class="flex-grow-1"
        avatar-color="#E3F2FD"
        icon-color="#1565C0"
        :img-src="require('@/assets/hoc_vien.svg')"
        :number-value="totalStudents"
        label="Học sinh"
        footer-text="Xem danh sách học sinh"
        @click-action="$router.push({ name: 'students' })"
      />

      <!-- Giáo viên -->
      <stat-card
        class="flex-grow-1"
        avatar-color="#FFF3E0"
        icon-color="#E65100"
        icon="mdi-teach"
        :number-value="totalTeachers"
        label="Giáo viên"
        footer-text="Xem danh sách giáo viên"
        @click-action="$router.push({ name: 'teachers' })"
      />
    </div>
  </div>
</template>

<script>
import { Student, Teacher, Class } from '@/plugins/api'
import StatCard from './StatCard.vue'
import get from 'lodash/get'

export default {
  name: 'DashboardSummary',
  components: {
    StatCard,
  },
  data: () => ({
    totalClasses: 0,
    totalStudents: 0,
    totalTeachers: 0,
    gradesData: [],
    loadingGrades: false,
  }),
  filters: {
    formatNumber(value) {
      if (!value) return 0
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
  },
  async created() {
    this.fetchSummary()
  },
  methods: {
    async fetchSummary() {
      this.loadingGrades = true
      try {
        const [gradeSummaryData, teachersRes] = await Promise.all([
          Class.gradeSummary().catch(() => ({})),
          Teacher.count().catch(() => 0)
        ])

        const grades = get(gradeSummaryData, 'grades', [])

        if (!Array.isArray(grades) || !grades.length) {
          this.gradesData = []
          this.totalStudents = 0
        } else {
          this.gradesData = grades.map(item => ({
            grade: item.gradeNumber,
            count: item.studentCount,
            classCount: item.classCount || 0,
          }))
          this.totalStudents = grades.reduce((sum, item) => sum + (item.studentCount || 0), 0)
        }

        this.totalClasses = get(gradeSummaryData, 'totalRunningClasses', 0)
        this.totalTeachers = teachersRes || 0
      } catch (error) {
        console.error('Error fetching dashboard summary:', error)
        this.gradesData = []
      } finally {
        this.loadingGrades = false
      }
    },
  },
}
</script>
